import { Injectable } from '@angular/core';
import { BonusService } from '../bonus/bonus.service';
import { Navigator } from 'src/app/components/menu/navigator';

@Injectable({
  providedIn: 'root'
})
export class BonusCollectionService {
  private bonusCollectionTimeout: any;
  private timeoutInterval: number = 1000;

  constructor(
    private bonusService: BonusService,
    public navigator: Navigator
    ) { }

  public validateAndNavigateToCollectBonus(bonusCode: string) {
    this.bonusService.callValidateBonus(bonusCode).subscribe(
      (response: any) => {
        if (response && !!response.result) {
          this.openBonusCollectionPopover(response);
        }
      },
      (error) => {
        switch (error.getErrorCode().toUpperCase()) {
          case 'INVALID_CODE':
            console.log('The bonus code is wrong or expired, please try another one.');
            this.navigator.openPopover( 'GlobalErrorPopoverComponent', error.getErrorMessage(), 'standard-popover global-error-popover', 
              true, true, true, -1, 'cover', true, false);
            break;
        }
      }
    );
  }

  private openBonusCollectionPopover(bonusData: any) {
    if (this.noActiveComponents()) {
      this.navigator.openPopover(
        'BonusCollectionComponent',
        bonusData.payload,
        'standard-popover marketing-notification',
        false, true, true, -1, 'cover', true, false
      );
    } else {
      this.setBonusCollectionTimeout(bonusData);
    }
  }

  private setBonusCollectionTimeout(bonusData: any) {
    this.clearBonusCollectionTimeout();
    this.bonusCollectionTimeout = setTimeout(() => {
      this.openBonusCollectionPopover(bonusData);
    }, this.timeoutInterval);
  }

  private clearBonusCollectionTimeout() {
    if (this.bonusCollectionTimeout) {
      clearTimeout(this.bonusCollectionTimeout);
      this.bonusCollectionTimeout = null;
    }
  }

  private noActiveComponents(): boolean {
    return this.navigator.activeModals.length === 0 &&
           this.navigator.activePriorityPopovers.length === 0 &&
           this.navigator.activePopovers.length === 0;
  }
}
